import { render, staticRenderFns } from "./moonStandard.vue?vue&type=template&id=1752af4e"
import script from "./moonStandard.vue?vue&type=script&lang=js"
export * from "./moonStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports